import { ModelCommon, UserAttributeDef, UserAttributeDefs, toDatePickerFormat, ValidModelType } from '@iotv/datamodel-core';
import { isValidBusinessObject, MapLike, PathDirection } from '@iotv/iotv-v3-types';

const typeName = 'IrrigatorSettingMessages';

export type IrrigatorSettingMessagesProps = {
  payload?: string;
  time?: string;
  signal?: string;
};

export class IrrigatorSettingMessages extends ModelCommon {
  constructor(ob: any) {
    super(ob.type || typeName, ob);
  }

  payload?: string;
  time?: string;
  signal?: string;

  getUserAttributes(): UserAttributeDefs {
    return {
      ...super.getUserAttributes(),
      payload: { type: 'String', editable: true, label: 'payload', name: 'payload', description: 'The raw payload ' },
      time: { type: 'String', editable: true, label: 'time', name: 'time', description: 'The time of the message (UTC)' },
      signal: { type: 'String', editable: true, label: 'signal', name: 'signal', description: 'The signal strength of the message' },
    };
  };
}
